
export const nycCollaborations = [
  {
    id: 1,
    brand: 'Sephora',
    type: 'Beauty & Cosmetics',
    description: '',
    thumbnail: 'https://readdy.ai/api/search-image?query=sephora%20beauty%20store%20interior%20luxury%20cosmetics%20display%20modern%20retail%20environment%20professional%20brand%20photography%20clean%20aesthetic%20makeup%20products%20elegant%20lighting%20vertical%20format%20sophisticated%20tones&width=450&height=800&seq=collabv1new&orientation=portrait'
  },
  {
    id: 2,
    brand: 'Nike',
    type: 'Athletic & Sportswear',
    description: '',
    thumbnail: 'https://readdy.ai/api/search-image?query=nike%20athletic%20sportswear%20brand%20content%20urban%20fitness%20lifestyle%20sneakers%20and%20activewear%20modern%20sports%20aesthetic%20professional%20photography%20dynamic%20energy%20vertical%20format%20bold%20tones&width=450&height=800&seq=collabv2new&orientation=portrait'
  },
  {
    id: 3,
    brand: 'Starbucks',
    type: 'Coffee & Lifestyle',
    description: '',
    thumbnail: 'https://readdy.ai/api/search-image?query=starbucks%20coffee%20cup%20and%20cafe%20interior%20cozy%20modern%20coffeehouse%20aesthetic%20warm%20inviting%20atmosphere%20lifestyle%20brand%20photography%20vertical%20format%20warm%20brown%20green%20tones&width=450&height=800&seq=collabv3new&orientation=portrait'
  },
  {
    id: 4,
    brand: 'Target',
    type: 'Retail & Lifestyle',
    description: '',
    thumbnail: 'https://readdy.ai/api/search-image?query=target%20retail%20store%20modern%20shopping%20lifestyle%20colorful%20products%20clean%20organized%20displays%20contemporary%20brand%20aesthetic%20professional%20photography%20vertical%20format%20bright%20red%20white%20tones&width=450&height=800&seq=collabv4new&orientation=portrait'
  },
  {
    id: 5,
    brand: 'Lululemon',
    type: 'Activewear & Wellness',
    description: '',
    thumbnail: 'https://readdy.ai/api/search-image?query=lululemon%20activewear%20yoga%20fitness%20lifestyle%20athletic%20clothing%20wellness%20brand%20aesthetic%20professional%20photography%20clean%20modern%20vertical%20format%20neutral%20athletic%20tones&width=450&height=800&seq=collabv5new&orientation=portrait'
  },
  {
    id: 6,
    brand: 'Apple',
    type: 'Technology & Lifestyle',
    description: '',
    thumbnail: 'https://readdy.ai/api/search-image?query=apple%20products%20iphone%20macbook%20airpods%20minimalist%20tech%20lifestyle%20sleek%20modern%20design%20professional%20brand%20photography%20clean%20aesthetic%20vertical%20format%20white%20silver%20tones&width=450&height=800&seq=collabv6new&orientation=portrait'
  },
  {
    id: 7,
    brand: 'Amazon',
    type: 'E-commerce & Lifestyle',
    description: '',
    thumbnail: 'https://readdy.ai/api/search-image?query=amazon%20delivery%20packages%20and%20shopping%20lifestyle%20modern%20e-commerce%20brand%20content%20professional%20photography%20clean%20contemporary%20aesthetic%20vertical%20format%20blue%20orange%20tones&width=450&height=800&seq=collabv7new&orientation=portrait'
  },
  {
    id: 8,
    brand: 'Whole Foods',
    type: 'Organic & Wellness',
    description: '',
    thumbnail: 'https://readdy.ai/api/search-image?query=whole%20foods%20organic%20produce%20fresh%20healthy%20food%20market%20lifestyle%20natural%20wellness%20brand%20aesthetic%20professional%20photography%20vibrant%20fresh%20vertical%20format%20green%20natural%20tones&width=450&height=800&seq=collabv8new&orientation=portrait'
  }
];
